import { FullScreenLoader } from '@slims-pro/ui/atoms';
import { Outlet } from 'react-router';
import { useMe } from '@/hooks/use-me';
import { useMeta } from '@/hooks/use-meta';
import { ApiError } from '@/lib/api';

/**
 * Loads `meta` and `me` before anything else renders. On 401 the API middleware is already
 * redirecting to the login (OIDC), so the loader stays up; other errors go to the route boundary.
 */
export function ProtectedRoute() {
	const meta = useMeta();
	const me = useMe();
	if (meta.error) throw meta.error;
	if (me.error && !(me.error instanceof ApiError && me.error.status === 401)) throw me.error;
	if (!meta.data || !me.data) return <FullScreenLoader />;
	return <Outlet />;
}
